module.exports = "/dashboard/components/nextShiftsComponent-83b351.html";